import _classCallCheck from "/opt/app/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/app/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/app/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/opt/app/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import { Form } from 'react-bootstrap';
import { Field } from 'react-final-form';
import { FieldLabel } from './FieldLabel';
import { FieldError } from './FieldError';

var BooleanField = function () {
  var BooleanField = /*#__PURE__*/function (_React$Component) {
    _inherits(BooleanField, _React$Component);

    var _super = _createSuper(BooleanField);

    function BooleanField() {
      var _this;

      _classCallCheck(this, BooleanField);

      _this = _super.apply(this, arguments);

      _this.renderIndicator = function (needIcons) {
        return React.createElement("span", {
          className: 'switcher-indicator'
        }, React.createElement("span", {
          className: 'switcher-yes'
        }, React.createElement("span", {
          hidden: !needIcons,
          className: 'ion ion-md-checkmark'
        })), React.createElement("span", {
          className: 'switcher-no'
        }, React.createElement("span", {
          hidden: !needIcons,
          className: 'ion ion-md-close'
        })));
      };

      return _this;
    }

    _createClass(BooleanField, [{
      key: "render",
      value: function render() {
        var _this2 = this;

        var _a = this.props,
            name = _a.name,
            isRequired = _a.isRequired,
            isReadonly = _a.isReadonly,
            label = _a.label,
            _a$variant = _a.variant,
            variant = _a$variant === void 0 ? 'default' : _a$variant,
            _a$placeholder = _a.placeholder,
            placeholder = _a$placeholder === void 0 ? 'Описание' : _a$placeholder,
            initialValue = _a.initialValue,
            rest = __rest(_a, ["name", "isRequired", "isReadonly", "label", "variant", "placeholder", "initialValue"]);

        var labelClassName = /checkbox/.test(variant) ? 'custom-control custom-checkbox' : 'switcher';
        labelClassName += /square/.test(variant) ? ' switcher-square' : '';
        var inputClassName = /checkbox/.test(variant) ? 'custom-control' : 'switcher';
        return React.createElement(Field, {
          name: name,
          type: 'checkbox',
          initialValue: initialValue,
          render: function render(_ref) {
            var input = _ref.input,
                meta = _ref.meta;
            return React.createElement(Form.Group, {
              controlId: name
            }, React.createElement(FieldLabel, Object.assign({}, label, {
              isRequired: isRequired
            })), React.createElement("div", null, React.createElement("label", Object.assign({}, input, rest, {
              className: labelClassName
            }), React.createElement("input", {
              type: 'checkbox',
              className: "".concat(inputClassName, "-input"),
              disabled: isReadonly,
              defaultChecked: initialValue
            }), _this2.renderIndicator(/with-icon/.test(variant)), React.createElement("span", {
              className: "".concat(inputClassName, "-label")
            }, placeholder))), React.createElement(FieldError, {
              error: meta.error
            }));
          }
        });
      }
    }]);

    return BooleanField;
  }(React.Component);

  BooleanField.defaultProps = {
    isReadonly: false,
    isRequired: false
  };
  return BooleanField;
}();

export { BooleanField };